import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import { ReactElement } from 'react'
import { ColumnDef, SortingState } from '@tanstack/react-table'
import { Button } from 'app/components/ui/button'
import { NavTabs } from 'app/components/ui/nav-tabs'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import SimpleTable from 'app/components/table/SimpleTable'
import { FilterableColumn } from 'app/filter.utils'
import type { UserJson } from 'app/types/entities'

export type ActiveUsersShadcnComponentProps = {
  users: { hits: UserJson[]; total: number } | undefined
  columns: ColumnDef<UserJson, any>[]
  filters: FilterableColumn[]
  initialSort?: SortingState
  canManageUsers: boolean
  canEditUser: boolean
  isOrgUser: boolean
  isSuperUser: boolean
  showTabs?: boolean
}

const tabs = [
  { name: `Active`, href: `/settings/users/active` },
  { name: `Invited`, href: `/settings/users/invited` },
]

export const ActiveUsersShadcnComponent = observer(function ActiveUsersShadcnComponent({
  users,
  columns,
  filters,
  initialSort,
  canManageUsers,
  canEditUser,
  isOrgUser,
  isSuperUser,
  showTabs = true,
}: ActiveUsersShadcnComponentProps): ReactElement {
  return (
    <PageScroll
      variant="table"
      header={
        <>
          <PageHeaderComponent
            title="Users"
            primaryButtonSlot={
              canEditUser ? (
                <Link to="/settings/users/new">
                  <Button variant="primary" size="sm">
                    + Add User
                  </Button>
                </Link>
              ) : undefined
            }
          />

          {showTabs && (
            <div className="mb-8">
              <NavTabs tabs={tabs} />
            </div>
          )}
        </>
      }
    >
      <SimpleTable
        data={users?.hits}
        columns={columns}
        filterableColumns={filters}
        showColumnOrdering
        enableExport={false}
        initialSort={initialSort}
        hideFooter
        edgePadded
      />
    </PageScroll>
  )
})
